var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sys-meta"},[_c('UserAvatar',{staticClass:"meta-avatar",attrs:{"user-avatar":_vm.meta.avatar}}),_c('div',{staticClass:"meta-body text-black line-clamp-text"},[_vm._v(" "+_vm._s(_vm.meta.corpName)+"-"+_vm._s(_vm.meta.name)),_c('span',{staticClass:"text-grey",staticStyle:{"padding":"0 4px"}},[_vm._v(_vm._s(_vm.act))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }